export interface VideoData {
    id: string;
    slug: string;
    title: string;
    description: string;
    thumbnail: string;
    url: string;
    publishedDate: string;
    duration: string;
    videoId?: string;
    views?: string;
}

// Define a unified Video interface if we want, or reuse VideoData
// For now, VideoData seems sufficient as it has everything we need.
// We can extend it if needed.

import videosData from '@/data/videos.json';

// Define a unified Video interface if we want, or reuse VideoData
// For now, VideoData seems sufficient as it has everything we need.
// We can extend it if needed.

const allVideos: VideoData[] = videosData as VideoData[];

class VideoService {
    getAllVideos(): VideoData[] {
        return allVideos;
    }

    getVideos(page: number, limit: number): { videos: VideoData[], total: number } {
        const start = (page - 1) * limit;
        const end = start + limit;
        return {
            videos: allVideos.slice(start, end),
            total: allVideos.length
        };
    }

    getRecentVideos(limit: number): VideoData[] {
        return this.getVideos(1, limit).videos;
    }

    getVideoBySlug(slug: string): VideoData | undefined {
        return allVideos.find(v => v.slug === slug);
    }

    getLatestVideo(): VideoData {
        return allVideos[0];
    }
}

export default new VideoService();
